import { OverBookingInfoResponse } from '@oy/types';
import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';

export function getOverbookingInfo() {
  return axios.request<OverBookingInfoResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/account/overbooking-info`,
  });
}
